import { render } from "./newscenter.vue?vue&type=template&id=d5274a80&scoped=true"
import script from "./newscenter.vue?vue&type=script&lang=js"
export * from "./newscenter.vue?vue&type=script&lang=js"

import "./newscenter.vue?vue&type=style&index=0&id=d5274a80&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5274a80"]])

export default __exports__